import MarkdownRenderer from '@/app/PageSpeed/components/audit-renderers/MarkdownRenderer';
import FalconCloseButton from '@/components/common/FalconCloseButton';
import { useState } from 'react';
import { Modal } from '@/components/common/AppModal';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { stopShowing } from '../reducers/notifShowSlice';
import { useNotifLogMutation } from '../api/notifApi';
import { useGetUserInfoQuery } from '../api/authApi';
import type { ReactNode } from 'react';

type NotificationData = {
  id: string | number;
  id_display?: string;
  title_dispaly?: ReactNode;
  name_dispaly?: ReactNode;
  content?: string | null;
  attachment?: string | null;
  attachment_is_video?: boolean;
  btn_text?: ReactNode;
  btn_url?: string;
};

type NotificationState = {
  notifShow: Array<string | number>;
};

type NotifModalProps = {
  popUpData: NotificationData;
};

const NotifModal = ({ popUpData }: NotifModalProps) => {
  const dispatch = useDispatch();
  const { data: userInfo, isError } = useGetUserInfoQuery();

  const [show, setShow] = useState(true);
  const notifShowState = useSelector(
    (state: NotificationState) => state.notifShow
  );
  const handleClose = () => {
    dispatch(stopShowing(popUpData?.id));
    setShow(false);
  };
  const [sendLog] = useNotifLogMutation();
  const sendLogHandler = async () => {
    try {
      if (!userInfo || isError) return;
      await sendLog({
        name: userInfo?.data?.first_name ?? '',
        family: userInfo?.data?.last_name ?? '',
        which_notif: popUpData?.id_display ?? '',
        path: window.location.href
      });
    } catch (error) {
      console.log(error);
    }
  };

  const hasAttachment = Boolean(popUpData?.attachment);

  return notifShowState?.includes(popUpData?.id) ? (
    <></>
  ) : (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        dialogClassName="notif-modal-dialog"
        contentClassName="notif-modal-content"
      >
        <Modal.Header className="align-items-start gap-2">
          <Modal.Title className="fs-0 text-break">
            {popUpData?.title_dispaly}
          </Modal.Title>
          <FalconCloseButton
            className="flex-shrink-0"
            onClick={async () => {
              try {
                handleClose();
                await sendLogHandler();
              } catch (error) {
                console.log(error);
              }
            }}
          />
        </Modal.Header>
        <Modal.Body className="fs--1 p-0">
          {hasAttachment &&
            (popUpData?.attachment_is_video ? (
              <video
                autoPlay
                muted
                playsInline
                loop
                controls
                className="w-100"
                style={{ maxHeight: '50vh', objectFit: 'contain' }}
              >
                <source src={popUpData?.attachment ?? undefined} />
              </video>
            ) : (
              <img
                src={popUpData?.attachment ?? undefined}
                alt=""
                className="img-fluid w-100"
              />
            ))}
          <div className="px-3 py-2 text-break">
            <h5 className="mt-3 mb-2 fw-semi-bold text-break">
              {popUpData?.name_dispaly}
            </h5>
            <div className="mb-2">
              <MarkdownRenderer content={popUpData?.content} />
            </div>
          </div>
        </Modal.Body>
        {popUpData?.btn_text && (
          <Modal.Footer className="flex-wrap">
            <Button
              as="a"
              href={popUpData?.btn_url}
              variant="secondary"
              className="mw-100 text-truncate"
              onClick={async () => {
                try {
                  popUpData?.btn_url
                    ? window.open(popUpData?.btn_url, '_blank')
                    : handleClose();
                  await sendLogHandler();
                } catch (e) {
                  console.log(e);
                }
              }}
              target="_blank"
            >
              {popUpData?.btn_text}
            </Button>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
};

export default NotifModal;
